module.exports = __webpack_public_path__ + "static/media/reading_template.2615485c.xlsx";